export default "__VITE_ASSET__K2cuU5MQ__"